import { motion } from 'framer-motion';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useCreateItems } from 'global/cnr/contexts/useHelpers/useCreateItems';
import { convertHelpers } from 'global/common/convert';
import AppForm from 'global/components/forms/appForms/AppForm';
import { appFormTypes } from 'global/enums/appFormTypes';
import { appIconTypes } from 'global/enums/appIconTypes';
import { gEnums } from 'global/enums/globalEnums';
import { settingsIconTypes } from 'global/enums/settingsIconTypes';
import { listListO } from 'global/lists/lists';
import { settingsHelpers } from 'global/viewSettings/helpers/settingsHelpers';
import { propDataOpts } from 'global/viewSettings/settingsProps/settingsAll';
import _ from 'lodash';
import { _matchDisplayTypes, MatchContentWithProvider } from 'projectSpecific/sports/elements/matches/MatchContent';
import { useContext, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Label } from 'semantic-ui-react'; // or your preferred icon library
import SortableGrid from 'SortableGrid';
import { _squareTypes } from './SquareSquares';
import { SquaresContext } from './SquaresWrapper';

const _iconSize = null

// Example transition — replace with your actual itemTransition if imported
const itemTransition = { duration: 0.25, ease: 'easeOut' };

export const _imsTypes = {
  parent: 'parent',
  normal: 'normal',
  inline: 'inline',
  match: 'match',
  matchFull: 'matchFull',
  team: 'team',
  event: 'event',
  queryList: 'queryList',
  sortSelect: 'sortSelect',
}

const ItemMenuSquares = ({
  access,
  activeItem,
  appDataDocuments,
  caption,
  currentData,
  fn_altContent,
  fn_subContent,
  fn_mainContent,
  fnAltData,
  group,
  icon: icon_main,
  iconColor: _iconColor,
  iconItem: icon_item,
  iconn: iconn_main,
  imsType = _imsTypes.normal,
  isFull,
  isGlobal,
  menuItems,
  noGap,
  noItemIcon,
  onCancel,
  onClick,
  onDrop,
  onSort,
  onRemove,
  squareType,
  withCancel,
  handleSelect
}) => {

  const _menuItems = _.cloneDeep(menuItems)

  if (!_.isArray(_menuItems)) {
    convertHelpers.createItemKeys(_menuItems, 'key')
  }

  let isInline = imsType === _imsTypes.inline ||
    imsType === _imsTypes.event ||
    imsType === _imsTypes.queryList ||
    imsType === _imsTypes.match ||
    imsType === _imsTypes.team ||
    imsType === _imsTypes.sortSelect

  const { showShow, allowGroups, allowSorting, allowSections, allowAltItem, allowAddItem } = useMemo(() => {

    let _allowSorting = false
    let _allowGroups = false
    let _showShow = false;
    let _allowSections = false
    let _allowAltItem = false
    let _allowAddItem = false

    switch (squareType) {
      case _squareTypes.pages_global:
        _allowAddItem = true
        break;
      case _squareTypes.pages_page:
        _allowGroups = true
        _allowSorting = true
        _showShow = true
        _allowAddItem = true
        break;
      case _squareTypes.pageProps:
        _allowGroups = isGlobal ? false : true
        _allowSorting = isGlobal ? false : true
        _showShow = true
        _allowAddItem = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageSections:
        _allowSorting = true
        _showShow = true
        _allowAddItem = true
        _allowSections = fnAltData ? true : false
        break;
      case _squareTypes.pageItems:
        _allowAltItem = true
        break;
      default:
      // nothing
    }

    switch (imsType) {
      case _imsTypes.sortSelect:
        _allowSorting = true
    }

    return { showShow: _showShow, allowGroups: _allowGroups, allowSorting: _allowSorting, allowSections: _allowSections, allowAltItem: _allowAltItem, allowAddItem: _allowAddItem }
  }, [squareType, currentData])

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { themeColors } = aps_global ?? {}

  const squaresContext = useContext(SquaresContext)
  const { squares_handlers, squares_state } = squaresContext ?? {}

  const create_fns = useCreateItems()

  const [showAdd, setShowAdd] = useState()
  const [showReorder, setShowReorder] = useState()

  const handleShow_add = () => setShowAdd(!showAdd)
  const handleShow_reorder = () => setShowReorder(!showReorder)
  const handleShow_sections = () => {
    const ps = fnAltData()
  }

  const cnc = [
    'item-menu-squares-container',
    imsType,
    !caption && 'nc',
    (allowSorting || allowGroups) && 'srt',
    showReorder && ' srdr',
    (noGap && 'ng')
  ].filter(Boolean).join(' ')

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => {
      onDrop(files)
    },
    accept: {
      'image/*': [],
      'application/pdf': [],
    },
    multiple: true,
  })

  const handleCancel = (e) => {
    e && e.stopPropagation()
    onCancel()
  }

  const itemCaption = (c) => c && <div className='sqr-box-caption'>{c} </div>

  const itemIcon = (item, itemKey, icon, iconColor, disabled, colors) => <div className='sqr-box-icon'>
    <Icon
      className='ims-item-icon'
      name={appIconTypes[itemKey] || colors?.icon || icon}
      color={iconColor || 'blue'}
      size={_iconSize}
      disabled={disabled}
      circular={showShow}
      inverted={showShow && item.show}
      onClick={(e) => onCancel && handleCancel(e)}
    />
  </div>

  const removeIcon = (item, itemKey, icon, iconColor, disabled, colors) => <div className='sqr-box-icon'>
    <Icon
      className='ims-item-remove'
      name={appIconTypes[itemKey] || colors?.icon || icon}
      color={iconColor || 'blue'}
      size={_iconSize}
      disabled={disabled}
      circular={showShow}
      inverted={showShow && item.show}
      onClick={(e) => onRemove && onRemove(e, item)}
    />
  </div>

  const div_inline = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, allowAltItem, disabled, colors } = divProps
    const { color, label } = item ?? {}
    const name = convertHelpers.getItemName(item, true)
    const _iconColor = color || iconColor
    return <div className='sqr-box'>
      {itemCaption(caption || name)}
      {!_.isNumber(count) && !isHeader && !noItemIcon && itemIcon(item, itemKey, icon, _iconColor, disabled, colors)}
      {_.isNumber(count) && !isHeader && <Label className='sqr-box-icon' circular size={'tiny'} color={count > 0 ? 'blue' : 'grey'}>{item.count}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {colors.bg &&
        <Label size='mini' className='sqr-box-oth' style={{ backgroundColor: colors.bg, color: colors.c }}>
          {'A'}
        </Label>}
      {label && label}
    </div>
  }

  const div_normal = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, disabled, captionCount } = divProps
    return <div className='sqr-box mtl'>
      {itemCaption(caption)}
      {!_.isNumber(count) && !isHeader && itemIcon(item, itemKey, icon, iconColor, disabled)}
      {_.isNumber(captionCount) && !isHeader && <Label className='sqr-box-oth' size={'mini'}>{captionCount}</Label>}
      {altContent && !isHeader && <div className='sqr-box-oth'>{altContent}</div>}
    </div>
  }

  const div_match = (divProps) => {
    const { item, isHeader, itemKey } = divProps
    const { away, home, startDate } = item ?? {}
    const { name: name_away } = away ?? {}
    const { name: name_home } = home ?? {}
    const name = `${name_away} @ ${name_home}`
    return <div className='sqr-box'>
      {itemCaption(name || item?.key)}
      {fn_altContent && !isHeader && <div className='sqr-box-oth'>{fn_altContent(item, itemKey)}</div>}
      {fn_subContent && !isHeader && <div className='sqr-box-sub'>{fn_subContent(item, itemKey)}</div>}
      {!fn_subContent && !isHeader && <div className='sqr-box-sub'>{startDate}</div>}
    </div>
  }

  const div_matchFull = (divProps) => {
    const { item } = divProps
    const propz = {
      matchDisplayType: _matchDisplayTypes.levelMatches,
      matchKey: item._itemKey,
      matchScheduleDisplayType: gEnums.matchScheduleDisplayTypes.levelDates
    }
    return <MatchContentWithProvider {...propz} />
  }

  const div_team = (divProps) => {
    const { item } = divProps
    const { name, sections, levels } = item ?? {}
    const caption = `${name} (${levels}-${sections})`
    return <div className='sqr-box'>
      {itemCaption(caption)}
    </div>
  }

  const div_event = (divProps) => {
    const { item, itemKey, caption, count, icon, iconColor, isHeader, altContent, disabled, captionCount } = divProps
    const { name } = item
    return <div className='sqr-box evt'>
      {itemIcon(item, itemKey, icon, iconColor, disabled)}
      {itemCaption(name || item?.key)}
    </div>
  }

  const div_queryList = (divProps) => {
    const { item, itemKey } = divProps
    const { dataPropName, queryType, propValues, propValue, propStringValue, valueIsString } = item
    const appDd = appDataDocuments?.[dataPropName]
    const appDdii = appDd?.[propValue] ? appDd?.[propValue]?.name : propValue

    let _appDdi;

    if (propValues) {
      let _propValues = propValues
      if (_.isObject(_propValues)) {
        _propValues = _.values(_propValues);
      }
      _appDdi = _.join(
        _.map(_propValues, pv => appDd?.[pv]?.name),
        ','
      )
    } else {
      if (valueIsString) {
        _appDdi = propStringValue
      } else {
        _appDdi = appDdii
      }
    }

    const name = `${dataPropName} : ${queryType} : ${_appDdi}`

    return <div className='sqr-box evt'>
      {itemCaption(name || item?.key)}
      {/* {itemIcon(item, itemKey, icon, 'delete', 'red')} */}
      {removeIcon(item, itemKey, 'delete', 'red')}
    </div>
  }

  const divItem = (divProps) => {
    switch (imsType) {
      case _imsTypes.parent:
        return fn_mainContent(divProps)
      case _imsTypes.inline:
      case _imsTypes.sortSelect:
        return div_inline(divProps)
      case _imsTypes.normal:
        return div_normal(divProps)
      case _imsTypes.match:
        return div_match(divProps)
      case _imsTypes.matchFull:
        return div_matchFull(divProps)
      case _imsTypes.team:
        return div_team(divProps)
      case _imsTypes.event:
        return div_event(divProps)
      case _imsTypes.queryList:
        return div_queryList(divProps)
      default:
        return div_inline(divProps)
    }
  }

  const renderIconDiv = (item, itemKey) => {
    const {
      _isFirstItem,
      allowAction,
      caption,
      count,
      data,
      disabled,
      icon,
      iconColor,
      isDrop,
      isHeader,
      key,
      selected,
      text,
      subText,
      triggerUrl,
      ui,
      altContent,
      display,
    } = item ?? {}

    const { caption: caption_display } = display ?? {}
    const name = convertHelpers.getItemName(item, true, false, true)

    let altItem;

    if (allowAltItem && item.key === 'props') {
      altItem = _.cloneDeep(item)
      altItem.key = 'propSections'
      altItem.caption = 'Prop Sections'
    }

    let _caption;
    let _icon = withCancel ? 'delete' : icon_item ? icon_item : 'arrow right';
    let _iconColor;
    let _key;
    let _captionCount;
    let _selected = activeItem && ((activeItem === name) || activeItem === item || activeItem === key || activeItem === item?._itemKey)

    if (_.isObject(item)) {
      if (_.isObject(caption)) {
        _caption = caption.text || _.startCase(itemKey)
        _captionCount = caption?.count || null
      } else {
        _caption = caption || _.startCase(key) || _.startCase(itemKey)
      }
      if (icon) { _icon = icon }
      if (iconColor) { _iconColor = iconColor }
      if (key) { _key = key }
    } else {
      _caption = _.startCase(item)
    }

    if (ui?.caption) { _caption = `${ui?.caption} - ${data?.formItemType}` }
    if (text) { _caption = `${text}` }
    if (name) { _caption = `${name}` }

    _caption = _caption.includes(',') ? _caption : _.startCase(_caption)

    if (caption_display && _.camelCase(caption_display) !== key) {
      _caption = `${caption_display} (${_.startCase(key)})`
    }


    const _cnd = [
      'imsc-item',
      selected && 'sel',
      isHeader && 'hdr',
      _selected && 'sel',
      currentData && currentData?.[key]?.allowAction && 'aa'
    ].filter(Boolean).join(' ')


    if (triggerUrl) { _iconColor = ' orange' }

    let _colors = { bg: null, c: null, icon: null }

    switch (group?.key) {
      case 'style':
      case 'styles':
      case 'themedColors':
      case 'themedItems':
        const propData = currentData?.[item.key]
        const { colors } = propData ?? {}
        const { backgroundColor, color } = colors ?? {}
        const _bgcolor = themeColors?.[backgroundColor]
        const _color = themeColors?.[color]
        _colors.bg = _bgcolor
        _colors.c = _color
        _colors.icon = settingsIconTypes[item.key]
        break;
      default:
      // nothing
    }

    const _isDrop = isDrop
    // if (isDrop) currentDropItem = item

    // on drop
    const grp = getRootProps()
    const _onClick = _isDrop ? grp.onClick : onClick
    delete grp.onClick

    const handle_click = (a, b) => {
      _onClick && _onClick(a, b)
    }

    if (_isFirstItem) return (
      <motion.div>
        <div style={{ padding: '.25em', textAlign: 'center' }}>
          <Icon name={'object ungroup outline'}
            color={'blue'}
            style={{ marginRight: '1em' }}
          />
          {_.startCase(item?.propSection)}
        </div>
      </motion.div>
    )

    const divProps = {
      allowAltItem,
      altContent,
      caption: _caption,
      captionCount: _captionCount,
      colors: _colors,
      count,
      disabled,
      icon,
      icon: _icon,
      iconColor: _iconColor,
      isHeader,
      item,
      itemKey,
    }

    if (imsType === _imsTypes.matchFull) {
      return div_matchFull(divProps)
    }

    return (
      <motion.div
        key={itemKey}
        layout
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 6 }}
        transition={itemTransition}
        className={`${_cnd} ${isDrop && isDragActive ? 'drag-active' : ''}`}
        onClick={() => handle_click && !disabled && !showReorder && !isHeader && handle_click(item, group)}
        {...(isDrop ? grp : {})}
      >
        {/* Dropzone input only for drop items */}
        {isDrop && <input {...getInputProps()} />}
        {divItem(divProps)}
        {subText && !isHeader && <div className='sqr-box-sub'>{subText} </div>}
      </motion.div >
    )
  };

  if (_.isEmpty(_menuItems)) { return; }

  let miCount = _.size(_menuItems)
  if (miCount > 3) { miCount = 3 }
  if (miCount === 1) { miCount = 2 }

  const cni = [
    'imsc-row-item',
    `sz-${isInline ? 1 : miCount}`,
  ].filter(Boolean).join(' ')

  const cn_cap = [
    'imsc-caption',
  ].filter(Boolean).join(' ')

  const handle_ammendSort = (items) => {
    const _items = _.cloneDeep(items)
    _.map(_items, (item, index) => {
      item.position = index
    })
    setShowReorder()
    if (isGlobal) {
      squares_handlers.handleAmmend_updateViewItemsInViews(true, _items, true)
    } else {
      squares_handlers.handleAmmend_updateViewItemsInViews(false, _items, true)
    }
  }

  const content_add = () => {
    const hs = async (data) => {
      switch (squareType) {
        case _squareTypes.pages_global:
          const opts = { forGlobal: true, createGenericProps: true, createPropSections: true, count: _.size(aps_viewItems) + 1 }
          const vi = create_fns.createViewItem(data.name, opts)
          squares_handlers.handleAmmend_viewItem(data.name, vi)
          break;
        case _squareTypes.pages_page:
          const vipp = _.cloneDeep(aps_viewItems[data.name])
          vipp.dataConstraints = {
            usePageConstraint: true,
            usePostPageConstraint: true,
            pageConstraintType: gEnums.pageConstraintTypes.arrayContains,
          };
          _menuItems[data.name] = vipp
          _menuItems[data.name].position = _.size(_menuItems)
          const _items = _.cloneDeep(_menuItems)
          squares_handlers.handleAmmend_updateViewItemsInViews(_items)
          break;
        case _squareTypes.pageProps:
          const _existingProps = {}
          const propSection = {}
          const propsToAdd = {
            [data.name]: { key: data.name }
          }
          const viP = await create_fns.createViewItemProps(propsToAdd, _existingProps, propSection)
          break;
      }
      handleShow_add()
    }
    const pd = {}

    switch (squareType) {
      case _squareTypes.pages_global:
        return <AppForm
          appFormType={appFormTypes.simpleInput}
          handleSave={hs}
          handleCancel={handleShow_add}
          data_parent={pd}
        />
      case _squareTypes.pages_page:
        const appFormItems = {
          name: settingsHelpers.newPropObject('name', propDataOpts(true, gEnums.formItemTypes.select, null, { trueList: listListO(aps_viewItems) })),
        }
        return <AppForm
          appFormItems={appFormItems}
          handleSave={hs}
          handleCancel={handleShow_add}
          data_parent={pd}
        />
    }
  }

  const content_sortable = () => {
    const menuItemz = _.sortBy(_menuItems, 'position')
    return <SortableGrid
      items={menuItemz}
      divFn={renderIconDiv}
      groupKey={group?.key}
      handleSave={handle_ammendSort}
      handleSelect={handleSelect || onClick}
      imsType={imsType}
      onSort={onSort}
      showApply={true}
      showReorder={showReorder}
    />
  }

  const content_normal = () => {
    return _.map(_menuItems, (item, itemKey) => renderIconDiv(item, itemKey))
  }

  if (showAdd) {
    return content_add()
  }

  if (imsType === _imsTypes.matchFull) {
    return content_normal()
  }

  if (allowSorting || allowGroups) {
    return (
      <div className={cnc} >
        {caption && <div className={cn_cap}>
          <Icon name={icon_main} color={_iconColor || 'blue'} style={{ marginRight: '1em' }} onClick={() => allowSections && handleShow_sections()} />
          {caption}
          <Icon name={'sort content ascending'} color={showReorder ? 'green' : 'grey'} style={{ marginLeft: '1em' }} onClick={() => handleShow_reorder()} />
          {allowAddItem && <Icon name={'add'} color={showAdd ? 'green' : 'grey'} style={{ marginLeft: '1em' }} onClick={() => handleShow_add()} />}
        </div>
        }
        <div className={cni} >
          {content_sortable()}
        </div>
      </div>
    );
  } else {
    return (
      <div className={cnc} style={isFull ? { height: '100%', padding: '1em' } : {}} >
        {caption && <div className={cn_cap} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
          <div>
            <Icon name={icon_main} color={_iconColor || 'blue'} style={{ marginRight: '1em' }} onClick={() => handleShow_reorder()} />
            {caption}
            {allowAddItem && <Icon name={'add'} color={showAdd ? 'green' : 'grey'} style={{ marginLeft: '1em' }} onClick={() => handleShow_add()} />}
          </div>
          <div>
            {iconn_main && <Icon name={iconn_main} color={_iconColor || 'blue'} />}
            {access && <Icon name={access?.icon || 'user'} color={access?.color || 'blue'} />}
          </div>
        </div>}
        <div className={cni} >
          {content_normal()}
        </div>
      </div>
    );
  }

};

export default ItemMenuSquares;
